import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getAutoOrderConditions } from 'interfaces/autoOrder';

const MultiPortal = () => {
    const navigate = useNavigate();
    const { v } = useParams();
    const [suppliers, setSuppliers] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSuppliers();
    }, []);

    const fetchSuppliers = async () => {
        const res = await getAutoOrderConditions();
        if (res && res.suppliers) {
            setSuppliers(res.suppliers);
        }
        setLoading(false);
    };

    const handleSupplierClick = (supplierId: string) => {
        const host = window.location.hostname.split(".");
        const subdomain = host[0];
        const isShopDomain = subdomain === 'shop' || window.location.hostname === 'shop.toola.fr';
        
        // If you are not on the shop domain, redirect to shop.toola.fr
        if (!isShopDomain && process.env.NODE_ENV === 'production') {
            window.location.href = `https://shop.toola.fr/command/${supplierId}`;
        } else {

            navigate(`/command/${supplierId}`);
        }
    };

    // If a specific provider is provided in the URL, redirect directly
    useEffect(() => {
        if (v) {
            const host = window.location.hostname.split(".");
            const subdomain = host[0];
            const isShopDomain = subdomain === 'shop' || window.location.hostname === 'shop.toola.fr';
            
            if (!isShopDomain && process.env.NODE_ENV === 'production') {
                window.location.href = `https://shop.toola.fr/command/${v}`;
            } else {
                navigate(`/command/${v}`);
            }
        }
    }, [v, navigate]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-slate-600">Chargement...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50 p-6">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-slate-800 mb-2">
                        Choisissez votre fournisseur
                    </h1>
                    <p className="text-slate-600">
                        Sélectionnez un fournisseur pour accéder à sa boutique B2B
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {suppliers.map((supplier: any) => (
                        <button
                            key={supplier.id}
                            onClick={() => handleSupplierClick(supplier.id)}
                            className="bg-white rounded-2xl shadow-lg border-2 border-slate-200 p-6 hover:border-blue-500 hover:shadow-xl transition-all group"
                        >
                            <div className="flex items-center gap-4">
                                {supplier.logo ? (
                                    <img
                                        src={supplier.logo}
                                        alt={supplier.name}
                                        className="w-16 h-16 object-contain rounded-lg"
                                    />
                                ) : (
                                    <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center">
                                        <span className="text-2xl font-bold text-white">
                                            {supplier.name.charAt(0).toUpperCase()}
                                        </span>
                                    </div>
                                )}
                                
                                <div className="flex-1 text-left">
                                    <h3 className="text-xl font-bold text-slate-800 group-hover:text-blue-600 transition-colors">
                                        {supplier.name}
                                    </h3>
                                    {supplier.description && (
                                        <p className="text-sm text-slate-600 mt-1">
                                            {supplier.description}
                                        </p>
                                    )}
                                </div>

                                <div className="text-blue-600 group-hover:translate-x-2 transition-transform">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </button>
                    ))}
                </div>

                {suppliers.length === 0 && (
                    <div className="text-center py-12">
                        <p className="text-slate-600">Aucun fournisseur disponible</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MultiPortal;